export default __webpack_public_path__ + "static/media/notification-toast.62994450.mp3";